import React from "react";
import { Table, Tag } from "antd";
import { BacktestSel, BacktestType } from "@/features/backtest";
import { useRootSelector } from "@/infrastructure/hooks";
import { round } from "lodash";

export default () => {
  const strategyTransaction = useRootSelector(BacktestSel.strategyTransaction).map(e => ({
    ...e,
    value: round(e.value, 2),
    action: e.value > 0 ? "Sell" : "Buy"
  }));

  const columns = [
    {
      title: "Date",
      dataIndex: "date",
      key: "date",
      ...getFilters("date")
    },
    {
      title: "Ticker",
      dataIndex: "symbol",
      key: "symbol",
      ...getFilters("symbol")
    },
    {
      title: "Executed Price",
      dataIndex: "price",
      key: "price"
    },
    {
      title: "Action",
      dataIndex: "action",
      key: "action",
      render: (value: string) => <Tag color={value === "Buy" ? "orange" : "cyan"}> {value}</Tag>,
      ...getFilters("action")
    },
    {
      title: "Size",
      dataIndex: "amount",
      key: "amount"
    },
    {
      title: "Value ($)",
      dataIndex: "value",
      key: "value"
    }
  ];

  return <Table columns={columns} dataSource={strategyTransaction} />;

  function getFilters(filter: keyof BacktestType.TransactionsRecords | "action") {
    return {
      filters: [...new Set(strategyTransaction.map(e => e[filter]))].map(e => ({
        text: e as string,
        value: e as string
      })),
      filterMultiple: true,
      onFilter: (value: any, record: any) => record[filter].indexOf(value) === 0
    };
  }
};
